"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * CardScan API
 * The official documentation for the CardScan API Clients.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.PhoneNumberType = {
    PcpPhone: 'pcp_phone',
    MemberServicesPhone: 'member_services_phone',
    ProviderServicesPhone: 'provider_services_phone',
    PharmacyServicesPhone: 'pharmacy_services_phone',
    DentalBenefitPhone: 'dental_benefit_phone',
    VisionBenefitPhone: 'vision_benefit_phone',
    TelemedicinePhone: 'telemedicine_phone'
};
